import { render, staticRenderFns } from "./RiskCriteria.vue?vue&type=template&id=ed08b5e0&scoped=true&"
import script from "./RiskCriteria.vue?vue&type=script&lang=js&"
export * from "./RiskCriteria.vue?vue&type=script&lang=js&"
import style0 from "./RiskCriteria.vue?vue&type=style&index=0&id=ed08b5e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed08b5e0",
  null
  
)

export default component.exports